import { TemporalEntityId } from 'entities-next/common'
import { getApiUserGroupHandlers, USER_GROUP_CACHE_STORE_ID, UserGroup } from 'entities-next/userGroup'
import React from 'react'
import { AsyncSelectField, AsyncSelectFieldProps } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { ExtendableStyles } from 'utils-next/types'

export type UserGroupSelectProps = ExtendableStyles &
  Omit<AsyncSelectFieldProps, 'promiseFn' | 'getOptionLabel' | 'getOptionSelected' | 'getCreatedOption' | 'cacheKey'>

function getUserGroupLabel(option: UserGroup) {
  return option.name
}

function getUserGroupSelected(option: UserGroup, value: UserGroup) {
  return option.id === value.id
}

function createUserGroup(inputValue: string): UserGroup {
  return { id: TemporalEntityId.new, name: inputValue, sortedFunnelStageIds: [] }
}

function cacheKeyFn() {
  return USER_GROUP_CACHE_STORE_ID
}

export function UserGroupSelect(selectProps: UserGroupSelectProps) {
  const { apiGetUserGroups } = getApiUserGroupHandlers()
  return (
    <AsyncSelectField
      promiseFn={apiGetUserGroups}
      getOptionLabel={getUserGroupLabel}
      getOptionSelected={getUserGroupSelected}
      onCreateOption={createUserGroup}
      allowCreation
      {...selectProps}
      cacheKeyFn={cacheKeyFn}
    />
  )
}
